import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export interface ITurnstileState {
  turnstileToken: string | null;
  isTurnstileScriptLoaded: boolean;
}

export const initialState: ITurnstileState = {
  turnstileToken: null,
  isTurnstileScriptLoaded: false,
};

const TurnstileSlice = createSlice({
  name: "turnstile",
  initialState: initialState,
  reducers: {
    setTurnstileToken: (state, action: PayloadAction<string | null>) => {
      state.turnstileToken = action.payload;
    },
    setIsTurnstileScriptLoaded: (state, action: PayloadAction<boolean>) => {
      state.isTurnstileScriptLoaded = action.payload;
    },
    resetTurnstile: (state) => {
      state.turnstileToken = null;
      state.isTurnstileScriptLoaded = false;
    },
  },
});

export const { setTurnstileToken, setIsTurnstileScriptLoaded, resetTurnstile } =
  TurnstileSlice.actions;

// Use useSelector directly to avoid circular dependency with store.ts
export const useTurnstileSlice = () =>
  useSelector((state: { turnstile: ITurnstileState }) => state.turnstile);

export { TurnstileSlice };
